import { useEffect } from "react";

/**
 * GA4 (gtag) e Meta Pixel quando REACT_APP_GA4_MEASUREMENT_ID / REACT_APP_META_PIXEL_ID estão definidos.
 */
const MarketingMeasurementScripts = () => {
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA4_MEASUREMENT_ID;
    if (gaId && typeof document !== "undefined" && !window.__xproGa4Injected) {
      window.__xproGa4Injected = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gaId)}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", gaId);
    }

    const pixelId = process.env.REACT_APP_META_PIXEL_ID;
    if (pixelId && typeof document !== "undefined" && !window.__xproMetaPixelInjected) {
      window.__xproMetaPixelInjected = true;
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(script);
      script.onload = () => {
        if (typeof window.fbq === "function") {
          window.fbq("init", pixelId);
          window.fbq("track", "PageView");
        }
      };
    }
  }, []);

  return null;
};

export default MarketingMeasurementScripts;
